(function ($) {
    Drupal.behaviors.mo19 = {
        attach() {
            $(once('mo19', 'body')).first().each(function () {
                const $mainNavigation = $('.MO19__nav');

                const iconTagClass = '.MO49__icon-tag';

                const options = {
                    attributes: true,
                    childList: true,
                    subtree: true
                };

                function cb(mutations) {
                    for (let mutation of mutations) {
                        let itemCount = 0;
                        $mainNavigation.find('.MO49__icon').each(function () {
                            let currentCount = 0;
                            if ($(this).find(iconTagClass).length) {
                                currentCount = parseInt($(this).find(iconTagClass).text());
                            }
                            itemCount += currentCount;
                        });

                        if (itemCount > 0) {
                            $(".MO19__burger-menu").addClass('MO49__icon-notif');
                        }
                    }
                }

                if ($('.MO49').length > 0) {
                    const observer = new MutationObserver(cb);
                    observer.observe($('.MO49').get(0), options);
                }
            });
        }
    }
})(jQuery);
